import { useState, useEffect } from 'react';
import { ProfileData } from '../modules/profile/types/profile';
import api from '../../features/auth/axiosConfig';

export const useProfile = () => {
  const [profileData, setProfileData] = useState<ProfileData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get(`/pos/profile`);
      setProfileData(response.data.message);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch profile data';
      setError(errorMessage);
      console.error("Error fetching profile data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return { 
    profileData, 
    loading, 
    error, 
    refetch: fetchProfile 
  };
};